import { initWorklet } from './play-audio.js'

export default class WsVoip {
  constructor() {
    this.socket = null
  }
  async connect(url) {
    this.socket = new WebSocket(url)
    this.workletNode = await initWorklet()
  }

  send(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(data)
    }
  }

  close() {
    if (this.socket) {
      this.socket.close()
    }
  }
}
